import React, { useContext } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { CONFIG } from '../config/general'
import { AppContext } from '../context/AppContext'
import { checkPermission } from '../helper/helper'

const Sidebar = () => {
  const location = useLocation()
  const { login } = useContext(AppContext);

  return (
    <div className="sideBar">
      <nav className="navbar navbar-expand-lg">
        <div className="container flex-lg-column g-0">
          <a className="navbar-brand m-0" href="#">
            <img src={CONFIG.REACT_APP_UPLOADS + "/Icons/logo.png"} style={{ height: "75px" }} alt="logo"
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = "./assets/images/logo.png";
              }} />
          </a>
          <button className="navbar-toggler" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasNavbar" aria-controls="offcanvasNavbar" aria-label="Toggle navigation">
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="offcanvas offcanvas-start" tabIndex="-1" id="offcanvasNavbar" aria-labelledby="offcanvasNavbarLabel">
            <div className="offcanvas-header">
              <button type="button" className="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
            </div>
            <div className="offcanvas-body pt-lg-5 pt-4">
              <ul className="navbar-nav flex-column align-items-center">
                <li className="nav-item">
                  <Link className={`nav-link fs-18 ${location.pathname === "/" ? "active" : ""}`} aria-current="page" to="/">
                    <i class="fas fa-house"></i> Home</Link>
                </li>
                {checkPermission(login.user, "usergroup:create_update") && <li className="nav-item">
                  <Link className={`nav-link fs-18 ${(location.pathname === "/users" || location.pathname.includes("viewUser")) ? "active" : ""}`} to="/users">
                    <i class="fas fa-user"></i> User</Link>
                </li>}
                {checkPermission(login.user, "usergroup:create_update") && <li className="nav-item">
                  <Link className={`nav-link fs-18 ${location.pathname === "/groups" ? "active" : ""}`} to="/groups">
                    <i class="fas fa-users"></i> Group</Link>
                </li>}
                {checkPermission(login.user, "usergroup:create_update") && <li className="nav-item">
                  <Link className={`nav-link d-flex fs-18 ${location.pathname === "/department" ? "active" : ""}`} to="/department">
                    <i class="fas fa-building"></i> Departments</Link>
                </li>}
                {checkPermission(login.user, "timetracking:read") && <li className="nav-item">
                  <Link className={`nav-link fs-18 ${location.pathname === "/tracker" ? "active" : ""}`} to="/tracker">
                    <i class="fas fa-clock"></i> Time Tracker</Link>
                </li>}
                {checkPermission(login.user, "screenshot:read") && <li className="nav-item">
                  <Link className={`nav-link fs-18 ${location.pathname === "/screenshots" ? "active" : ""}`} to="/screenshots">
                    <i class="fas fa-camera"></i> ScreenShots</Link>
                </li>}
                {checkPermission(login.user, "chat:view") && <li className="nav-item">
                  <Link className={`nav-link fs-18 ${location.pathname === "/chat" ? "active" : ""}`} to="/chat">
                    <i class="fas fa-comments"></i> Chat</Link>
                </li>}
                {checkPermission(login.user, "timetracking:read") && <li className="nav-item">
                  <Link className={`nav-link fs-18 ${location.pathname === "/warnings" ? "active" : ""}`} to="/warnings">
                    <i class="fas fa-warning"></i> Warnings</Link>
                </li>}
                <li className="nav-item main-tooltip">
                  <a className={`nav-link fs-18 ${location.pathname === "/themes" ? "active" : ""}`} to="/themes" aria-disabled>
                    <i class="fas fa-paint-brush"></i> Theme</a>
                  <span className="tooltip">Coming Soon</span>
                </li>
                {checkPermission(login.user, "settings:read") && <li className="nav-item">
                  <Link className={`nav-link fs-18 ${location.pathname === "/settings" ? "active" : ""}`} to="/settings">
                    <i class="fas fa-cog"></i> Setting</Link>
                </li>}
              </ul>
            </div>
          </div>
        </div>
      </nav>
    </div>
  )
}

export default Sidebar
